import { useMemo } from 'react'
import { Stack } from '@chakra-ui/react'

import { CustomFormViewerQuestionProps } from 'components/tools/CustomForm/types/CustomFormViewerQuestionProps'
import CustomFormCPFQuestion from './views/CustomFormCPFQuestion'
import CustomFormCTPSQuestion from './views/CustomFormCTPSQuestion'
import CustomFormPISQuestion from './views/CustomFormPISQuestion'

type KeyStringWithElement = {
  [key: string]: JSX.Element
}

export default function CustomFormDocumentsQuestions(props: CustomFormViewerQuestionProps) {
  const RenderEntityComponent = useMemo(() => {
    const possibleEntities: KeyStringWithElement = {
      CPF: <CustomFormCPFQuestion {...props} />,
      CTPS: <CustomFormCTPSQuestion {...props} />,
      PIS: <CustomFormPISQuestion {...props} />,
    }

    return possibleEntities[props.question.entity as string]
  }, [props.question])

  return <Stack>{RenderEntityComponent}</Stack>
}
